import { Option, Schema } from 'effect';

/**
 * A backend image path that still carries the LiipImagine `{filter}`
 * placeholder, e.g. `/media/cache/resolve/{filter}/be/01/foo.webp`.
 *
 * The backend owns the template and the rendering slot owns the filter:
 * `resolveImageUrl(template, ImageFilter.<slot>)` turns the pair into a URL.
 * Decoding rejects a path without the placeholder, so a resolved URL cannot
 * pass for a template.
 */
export const ImageTemplate = Schema.String.check(Schema.isIncludes('{filter}')).pipe(
  Schema.brand('ImageTemplate')
);

export type ImageTemplate = typeof ImageTemplate.Type;

const decodeImageTemplate = Schema.decodeUnknownOption(ImageTemplate);

/**
 * A nullable backend image path as an {@link ImageTemplate}.
 *
 * A missing path and a path without the `{filter}` placeholder both answer
 * `None`. An adapter builds every capability image field through this, so an
 * unusable image is an absent image and never a failed capability read.
 */
export const toImageTemplate = (raw: string | null | undefined): Option.Option<ImageTemplate> =>
  Option.flatMap(Option.fromNullishOr(raw), decodeImageTemplate);
